import React from "react";
import clsx from "clsx";

interface SkeletonBackgroundProps {
  className?: string;
  animate?: boolean;
  children?: React.ReactNode;
  variant?: "default" | "card" | "table" | "text";
  height?: string;
  width?: string;
  rounded?: boolean;
}

const SkeletonBackground = ({
  className,
  animate = true,
  children,
  variant = "default",
  height,
  width,
  rounded = true,
}: SkeletonBackgroundProps) => {
  // Base styles for all variants
  const baseStyles = "overflow-hidden bg-gray-200 dark:bg-theme-color-light";

  // Variant-specific styles
  const variantStyles = {
    default: "",
    card: "p-4 shadow-sm",
    table: "p-2",
    text: "h-4",
  };

  // Custom dimensions if provided
  const dimensionStyles = {
    height: height ? `h-${height}` : "",
    width: width ? `w-${width}` : "",
  };

  // Border radius styles
  const roundedStyles = rounded ? "rounded" : "";

  return (
    <div
      className={clsx(
        baseStyles,
        variantStyles[variant],
        dimensionStyles.height,
        dimensionStyles.width,
        roundedStyles,
        animate && "animate-pulse",
        className,
      )}
    >
      {children}
    </div>
  );
};

export default SkeletonBackground;
